<template>
    <router-view></router-view>
</template>
  
<script>
  export default {
    name: 'App'
  };
</script>
  
<style>
  @import 'paper-dashboard/assets/css/paper-dashboard.css';
  @import 'paper-dashboard/assets/css/demo.css';
  @import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
  
  .card .card-header .card-title {
    margin-top: 10px;
  }
</style>